import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'remarkLink' })
export class RemarkLinkPipe implements PipeTransform {
  constructor() {}

  transform(value: string): string {
    if (!value) return '';
    const replaced = value.replace(/\/userCentre\/kyc/g, `<span class="userCenter-kyc text-primary">KYC page</span>`);
    return replaced;
  }
}
